import R from 'ramda'

const REACTION_DISPLAY_TYPE = 'Match Reaction'
const REACTION_TRIGGER_TYPE = 'REACTION'

const isReactionFormTrigger = R.propEq('type', REACTION_DISPLAY_TYPE)

const convertReactionFormTriggerToWidgetTrigger = R.applySpec({
  type: R.always(REACTION_TRIGGER_TYPE),
  data: R.prop('value'),
  operator: R.always('AND'),
  primary: R.T
})

export { isReactionFormTrigger, convertReactionFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/form-to-widget/reaction.js